import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import seoMeta from './data/seoMeta.json'
import { cityPageMap } from './data/cityPages'

import './assets/interactions'

const setMeta = (selector, attribute, value) => {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    const match = selector.match(/\[(name|property)="([^"]+)"\]/)
    if (match) element.setAttribute(match[1], match[2])
    document.head.appendChild(element)
  }
  element.setAttribute(attribute, value)
}

router.afterEach((to) => {
  const pageSeo = to.meta.slug ? cityPageMap[to.meta.slug] : null
  const seo = pageSeo?.title ? pageSeo : seoMeta.default
  const canonicalUrl = `${window.location.origin}${to.path}`
  const ogImage = seo.ogImage?.startsWith('http') ? seo.ogImage : `${window.location.origin}${seo.ogImage || seoMeta.default.ogImage}`

  document.title = seo.title
  setMeta('meta[name="description"]', 'content', seo.description)
  setMeta('meta[property="og:title"]', 'content', seo.ogTitle || seo.title)
  setMeta('meta[property="og:description"]', 'content', seo.ogDescription || seo.description)
  setMeta('meta[property="og:type"]', 'content', 'website')
  setMeta('meta[property="og:url"]', 'content', canonicalUrl)
  setMeta('meta[property="og:image"]', 'content', ogImage)
})

createApp(App).use(router).mount('#app')

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]')
  if (!link) return

  const href = link.getAttribute('href')
  if (
    !href ||
    href.startsWith('#') ||
    href.startsWith('tel:') ||
    href.startsWith('sms:') ||
    href.startsWith('mailto:') ||
    link.target === '_blank' ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.defaultPrevented
  ) {
    return
  }

  const url = new URL(href, window.location.href)
  if (url.origin !== window.location.origin) return

  event.preventDefault()
  router.push(`${url.pathname}${url.search}${url.hash}`)
})
